<div class="accordion" [ngClass]="{'border-collapsed': isCollapsed, 'border-expanded': !isCollapsed}">

  <div class="accordion__header" (click)="collapse()">
    <div class="accordion__header-title">
      <div class="accordion__header-title__label">
        <bzg-icon nameIcon="icon-filters"></bzg-icon>
        <h2>{{ 'TRACE.FILTERS' | translate}}</h2>
      </div>
      <svg class="accordion__header-title__icon" [ngClass]="{'rotate-icon': !isCollapsed}">
        <use href="#icon-arrow-down-bold"></use>
      </svg>
    </div>
  </div>

  <div *ngIf="!isCollapsed" class="accordion__content">
    <div class="accordion-separator"></div>
    <div class="accordion__filter">

      <div class="accordion__filter-element">
        <span class="accordion__filter-label">{{'TRACE.CATEGORY' | translate}}
          <span>*</span>
        </span>
        <bzg-select [placeholder]="'Category'" [(value)]="selectedCategory">
          <bzg-option *ngFor="let category of categories" [value]="category">{{category}}</bzg-option>
        </bzg-select>
      </div>

      <!-- <div class="accordion__filter-element">
        <span class="accordion__filter-label">{{'TRACE.SOURCE' | translate}}
          <span>*</span>
        </span>
        <bzg-select [placeholder]="'Source'" [(value)]="selectedSource">
          <bzg-option *ngFor="let source of sources" [value]="source">{{source}}</bzg-option>
        </bzg-select>
      </div> -->

      <div class="accordion__filter-element">
        <bzg-input [(ngModel)]="fileNameFilter" placeholder="{{'TRACE.FILTER_FILE_NAME' | translate}}"
          name="fileNameFilter" id="fileNameFilter">
          {{'TRACE.FILTER_FILE_NAME' | translate}}
        </bzg-input>
      </div>

      <div class="accordion__filter-date">
        <div class="accordion__filter-title">
          <bzg-checkbox [ngModel]="disabledCreationDate" (ngModelChange)="disabledCreationDate = !disabledCreationDate" [checked]="!disabledCreationDate" >
          </bzg-checkbox>
          <span title="{{'TRACE.MESSAGE_CREATION_AUX' | translate}}">{{'TRACE.MESSAGE_CREATION' | translate}}</span>
        </div>
        <div>
          <bz-date-filter [isDisabled]="disabledCreationDate" [dateMin]="dateMinCreation" [dateMax]="dateMaxCreation" [showMessage]="showMessage" (onBtnFilterClick)="filterFileTraces($event, 0)" [isEventChange]="true">
          </bz-date-filter>
        </div>
      </div>

      <div class="accordion__filter-date">
        <div class="accordion__filter-title">
          <bzg-checkbox [ngModel]="disabledModificationDate" (ngModelChange)="disabledModificationDate = !disabledModificationDate" [checked]="!disabledModificationDate" >
          </bzg-checkbox>
          <span title="{{'TRACE.MESSAGE_MODIFICATION_AUX' | translate}}">{{'TRACE.MESSAGE_MODIFICATION' | translate}}</span>
        </div>
        <div>
          <bz-date-filter [isDisabled]="disabledModificationDate" [dateMin]="dateMinModified" [dateMax]="dateMaxModified" [showMessage]="showMessage" (onBtnFilterClick)="filterFileTraces($event, 1)" [isEventChange]="true">
          </bz-date-filter>
        </div>
      </div>

      <div class="accordion__filter-btn" >
        <bzg-button-primary [disabled]="disabledButton()" (click)="getFilesNames()">{{'TRACE.APPLY_FILTERS' | translate}}</bzg-button-primary>
      </div>
    </div>
  </div>
</div>



